var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content ht-100v pd-0"},[_c('iframe',{staticClass:"rpt-frame",attrs:{"src":`https://academy-reportv5.gosmart.mn/reportv5?access_token=${_vm.$store.state.user.token}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }